<template>
  <el-pagination
    @size-change="onSizeChange"
    @current-change="onCurrentChange"
    :current-page="current"
    :page-sizes="[10, 20, 50, 100]"
    :page-size="pageSize"
    :total="totalCount"
    layout="total, sizes, prev, pager, next, jumper"
  ></el-pagination>
</template>

<script>
export default {
  props: {
    current: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  methods: {
    onSizeChange(val) {
      this.$emit("size-change", val);
    },
    onCurrentChange(val) {
      this.$emit("current-change", val);
    },
  },
};
</script>

<style lang="scss" scoped></style>
